import { format as toFormat } from 'date-fns';
import PropTypes from 'prop-types';
import Tooltip from '../../Atoms/Tooltip/Tooltip';

/*
#tailwind
*/

const Timestamp = ({ time, format, ...other }) => {
  const formattedTime = time ? toFormat(time, format) : null;
  return (
    <Tooltip
      content={
        <>
          <div>{toFormat(time, 'P')}</div>
          <div>{toFormat(time, 'pp')}</div>
        </>
      }
    >
      <time {...other}>{formattedTime}</time>
    </Tooltip>
  );
};

Timestamp.propTypes = {
  time: PropTypes.number.isRequired,
  format: PropTypes.string,
};

Timestamp.defaultProps = {
  format: 'p',
};

export default Timestamp;
